import { RetainedAmountDTO } from "../types/RetainedAmount";
import { normalizeFetchError, getApiErrorMessage } from "./apiError";
import { apiFetch } from "./apiFetch";

const API_URL = process.env.REACT_APP_API_URL;

export async function getRetainedAmounts(
  companyId: string,
  documentId: string
) {
  const res = await apiFetch(
    `${API_URL}/documents/${documentId}/retained-amounts?companyId=${companyId}`
  );

  if (!res.ok) {
    throw new Error(
      await getApiErrorMessage(res, "Nie udało się pobrać kwot zatrzymanych.")
    );
  }

  const data = await res.json();
  return data.value as RetainedAmountDTO[];
}

export async function saveRetainedAmounts(
  companyId: string,
  documentId: string,
  rows: {
    retainedAmount: number;
    retainingDate: string;
  }[]
) {
  try {
    const res = await apiFetch(
      `${API_URL}/documents/${documentId}/retained-amounts?companyId=${companyId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(rows),
      }
    );

    if (!res.ok) {
      throw new Error(
        await getApiErrorMessage(res, "Nie udało się zapisać kwot zatrzymanych.")
      );
    }
  } catch (e) {
      throw normalizeFetchError(e, "Nie udało się zapisać kwot zatrzymanych.");
  }
}
